import { useState } from "react";

const defaultDrawerState = { open: false, type: '', data: null };

const useDrawer = () => {
  const [drawer, setDrawer] = useState(defaultDrawerState);

  const openDrawer = (type, data) => {
    setDrawer((drawer) => ({ ...drawer, type, open: true, data }));
  };
  const closeDrawer = () => {
    setDrawer(defaultDrawerState)
  }

  return { drawer, openDrawer, closeDrawer };
};

export default useDrawer;